import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IconComponent } from '../../icons/icon.component';
import { ButtonComponent } from '../ui/button/button.component';

export interface PromptDetailField {
  label: string;
  value: any;
  isFullWidth?: boolean;
}

export interface PromptDetailData {
  title: string;
  fields: PromptDetailField[];
  highlightValue?: string;
  highlightLabel?: string;
}

@Component({
  selector: 'app-prompt-detail-modal',
  standalone: true,
  imports: [CommonModule, IconComponent, ButtonComponent],
  templateUrl: './prompt-detail-modal.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./prompt-detail-modal.component.scss']
})
export class PromptDetailModalComponent {
  data = inject<PromptDetailData>(MAT_DIALOG_DATA);
  dialogRef = inject(MatDialogRef<PromptDetailModalComponent>);

  close() {
    this.dialogRef.close();
  }

  copyToClipboard(text: string) {
    if (!text) return;
    navigator.clipboard.writeText(text);
    // Could add a toast message here
  }
}
